import { render, staticRenderFns } from "./ProfileCustomerAddress.vue?vue&type=template&id=958879e8&"
import script from "./ProfileCustomerAddress.vue?vue&type=script&lang=js&"
export * from "./ProfileCustomerAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports